var isKind = require('./isKind');
    /**
     */
    var isArray = Array.isArray || function (val) {
        return isKind(val, 'Array');
    };
    module.exports = isArray;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/lang/isArray.js
// module id = 47
// module chunks = 1